import React from 'react';
import {Grid} from '../../components/LayoutComponents';
import {
  Group,
  Headline,
  LibraryLinkedTile
} from './librarySelectionSubComponents';
import {LibraryGroup} from '../../types';
import {useRoutes} from '../../services/route.service';
import {Flex, Heading} from '@chakra-ui/react';

export const LibrarySelection: React.FC<{
  libraryGroups: LibraryGroup[];
  lastLibrary?: string;
}> = ({libraryGroups, lastLibrary}) => {
  const RouteService = useRoutes();
  return (
    <Flex flexDir='column' gap='32px'>
      {libraryGroups.map((libGroup, i) => (
        <Group disablePadding key={i}>
          <Heading as='h2' size='sm'>
            {libGroup.libraryGroup}
          </Heading>
          <Grid maxCols={3} padding={false}>
            {libGroup.content.map(libGroupItem =>
              LibraryLinkedTile(
                (lastLibrary &&
                  libGroupItem.id === lastLibrary && {
                    ...libGroupItem,
                    ...{isActive: true}
                  }) ||
                  libGroupItem,
                RouteService.libraryRoute(libGroupItem.id)
              )
            )}
          </Grid>
        </Group>
      ))}
    </Flex>
  );
};
